"use client";

import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative w-full py-20 px-6 !bg-[hsl(213,94%,68%)] md:py-24 lg:py-28">
      <div className={`mx-auto max-w-4xl text-center transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
        <h2 className="mb-4 text-3xl font-bold leading-tight text-foreground-primary md:text-4xl lg:text-5xl">
          Ready to Build Your Restaurant's Email List?
        </h2>
        <p className="mb-8 text-lg text-foreground-primary/90 md:text-xl lg:mb-10">
          Partner with Click Viral to accelerate list growth, boost repeat visits, and drive sustainable revenue. Let's turn diners into loyal patrons.
        </p>
        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button asChild size="lg" variant="outline" className="w-full bg-background text-foreground hover:bg-background/90 hover:scale-[1.02] transition-all duration-[80ms] ease-in-out sm:w-auto">
            <Link to="/ContactPage">Request a Quote</Link>
          </Button>
          <Button asChild size="lg" variant="secondary" className="w-full hover:scale-[1.02] transition-all duration-[80ms] ease-in-out sm:w-auto">
            <Link to="/ContactPage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-secondary-foreground shadow-xs h-10 rounded-md px-6 has-[>svg]:px-4 w-full transition-all duration-[80ms] ease-in-out !bg-[hsl(0,0%,100%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-secondary/80 hover:scale-[1.02] sm:w-auto">Talk to an Expert</Link>
          </Button>
        </div>
      </div>
    </section>;
}